import { render, staticRenderFns } from "./cowIndividualCalvingAbortion.vue?vue&type=template&id=5a91722a&scoped=true&"
import script from "./cowIndividualCalvingAbortion.vue?vue&type=script&lang=js&"
export * from "./cowIndividualCalvingAbortion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a91722a",
  null
  
)

export default component.exports